import * as THREE from 'three';
import Experience from '../Experience.js';
import Resources from '../Utils/Resources.js';

import Hair from './Hair.js';
import Face from './Face.js';
import Body from './Body.js';
import Data from '../Utils/Data.js';
import AudioManager from './AudioManager.js';
import MeshUI from './MeshUI.js';


export default class Tamagochi {
    constructor() {
        this.experience = Experience.getInstance();
        this.scene = this.experience.scene;
        this.camera = this.experience.camera;
        this.time = this.experience.time;
        this.renderer = this.experience.renderer.instance;
        this.debug = this.experience.debug;
        this.sizes = this.experience.sizes;
        this.resources = Resources.getInstance();

        //HTML
        this.messageElements = [
            document.getElementById("love-msg"),
            document.getElementById("hate-msg"),
            document.getElementById("full-msg"),
            document.getElementById("hungry-msg"),
            document.getElementById("excited-msg"),
            document.getElementById("depressed-msg"),
            document.getElementById("final-msg"),
        ];

        //Audios
        this.audioMessages = [
            '/audios/kiss.mp3',
            '/audios/grunt.mp3',
            '/audios/eat.mp3',
            '/audios/sob.mp3',
            '/audios/laugh.mp3',
            '/audios/yawn.mp3',
        ];

        this.data = new Data();
        this.body = new Body();
        this.face = new Face(this.body.sphere);
        this.hair = new Hair(this.body.sphere);
        this.audioManager = new AudioManager();

        this.addMoodChanges();
    }

    addMoodChanges() {
        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder('Creature Stats');

            this.loveControl = this.debugFolder.add(this.data.creatureStats, 'love').name('Love').min(0).max(100).step(5).onChange(() => this.loveUpdated());
            this.foodControl = this.debugFolder.add(this.data.creatureStats, 'food').name('Food').min(0).max(100).step(5).onChange(() => this.foodUpdated());
            this.activityControl = this.debugFolder.add(this.data.creatureStats, 'activity').name('Activity').min(0).max(100).step(5).onChange(() => this.activityUpdated());
        }
        else {
            this.ui = new MeshUI();
            document.addEventListener("sliderUpdated", (event) => {
                this.onSliderUpdate(event.detail.id);
            });
        }
    }

    onSliderUpdate(sliderId) {
        if (sliderId === "love-slider") {
            this.loveUpdated();
        } else if (sliderId === "food-slider") {
            this.foodUpdated();
        } else if (sliderId === "activity-slider") {
            this.activityUpdated();
        }
    }

    loveUpdated() {
        this.updateExpression();
        this.updateColors();
        this.updateBreathing(true);

        if (this.data.creatureStats.love == 100)
            this.showLoveAnimation();
        else if (this.data.creatureStats.love == 0)
            this.showHateAnimation();
        else {
            this.updateLoveMessages();
        }
    }

    foodUpdated() {
        this.updateExpression();
        this.updateColors();

        if (this.data.creatureStats.food == 100)
            this.showFullAnimation();
        else if (this.data.creatureStats.food == 0)
            this.showHungryAnimation();
        else {
            this.updateFoodMessages();
        }
    }

    activityUpdated() {
        this.updateExpression();
        this.updateColors();
        this.updateBreathing(false);
        this.updateHairSpeed();

        if (this.data.creatureStats.activity == 100)
            this.showExcitedAnimation();
        else if (this.data.creatureStats.activity == 0)
            this.showDepressedAnimation();
        else {
            this.updateActivityMessages();
        }
    }

    showLoveAnimation() {
        this.data.currentState = this.data.State.LOVE;

        this.blockEverything();

        this.face.loadFaceExpresion();
        this.showFinalMessage();
        this.audioManager.playFinalAudio('/audios/love.mp3');


        this.body.forwardAnimation();
        this.body.tiltAnimation();
    }

    showHateAnimation() {
        this.data.currentState = this.data.State.HATE;

        this.blockEverything();

        this.face.loadFaceExpresion();
        this.showFinalMessage();
        this.audioManager.playFinalAudio('/audios/hate.mp3');

        this.body.forwardAnimation();
    }

    showFullAnimation() {
        this.data.currentState = this.data.State.FULL;

        this.blockEverything();

        this.face.loadFaceExpresion();
        this.showFinalMessage();
        this.audioManager.playFinalAudio('/audios/vomit.mp3');
    }

    showHungryAnimation() {
        this.data.currentState = this.data.State.HUNGRY;

        this.blockEverything();

        this.face.loadFaceExpresion();
        this.showFinalMessage();
        this.audioManager.playFinalAudio('/audios/pop.mp3');

        this.timeout = setTimeout(() => {
            this.body.sphere.visible = false;
        }, 2300);
    }

    showExcitedAnimation() {
        this.data.currentState = this.data.State.EXCITED;

        this.blockEverything();

        this.face.loadFaceExpresion();
        this.showFinalMessage();
        this.audioManager.playFinalAudio('/audios/explode.mp3');

        //Explotar
        this.body.explode();
        this.hair.explode();
    }


    showDepressedAnimation() {
        this.data.currentState = this.data.State.DEPRESSED;

        this.blockEverything();

        this.face.loadFaceExpresion();
        this.showFinalMessage();
        this.audioManager.playFinalAudio('/audios/sleep.mp3');
    }

    showFinalMessage() {
        this.messageElement.style.display = "none";

        this.messageElements[6].src = `/messages/${this.data.currentState}6.png`;
        this.messageElements[6].style.display = "block";

        // this.timeout = setTimeout(() => { 
        // }, 500);
    }

    showMessage(message, id) {
        if (this.messageElement && this.messageElement.style.display == "block")//If already in view
            this.messageElement.style.display = "none";

        switch (message) {
            case this.data.State.LOVE:
                this.messageElement = this.messageElements[0];
                this.audioManager.playAudio(this.audioMessages[0]);
                break;
            case this.data.State.HATE:
                this.messageElement = this.messageElements[1];
                this.audioManager.playAudio(this.audioMessages[1]);
                break;
            case this.data.State.FULL:
                this.messageElement = this.messageElements[2];
                this.audioManager.playAudio(this.audioMessages[2]);
                break;
            case this.data.State.HUNGRY:
                this.messageElement = this.messageElements[3];
                this.audioManager.playAudio(this.audioMessages[3]);
                break;
            case this.data.State.EXCITED:
                this.messageElement = this.messageElements[4];
                this.audioManager.playAudio(this.audioMessages[4]);
                break;
            case this.data.State.DEPRESSED:
                this.messageElement = this.messageElements[5];
                this.audioManager.playAudio(this.audioMessages[5]);
                break;
        }

        this.messageElement.src = `/messages/${message}${id}.png`;
        this.messageElement.style.display = "block";

        this.timeout = setTimeout(() => {
            this.messageElement.style.display = "none";
        }, 2000);

    }


    updateExpression() {
        const mapToRange = (value) => (value - 50); // Convert from [0,100] to [-50,50]

        const weightFunction = (value) => Math.sign(value) * Math.pow(Math.abs(value), 1.2); // Apply non-linear weighting

        const love = weightFunction(mapToRange(this.data.creatureStats.love));
        const food = weightFunction(mapToRange(this.data.creatureStats.food));
        const activity = weightFunction(mapToRange(this.data.creatureStats.activity));

        // Weighted average mood
        const average = Math.floor((love + food + activity) / 3 + 50); // Shift back to [0,100]

        // Assign face states based on the new weighted average
        if (average <= 20) this.data.currentState = this.data.State.ANGRY;
        else if (average <= 38) this.data.currentState = this.data.State.SAD;
        else if (average <= 45) this.data.currentState = this.data.State.WTF;
        else if (average <= 54) this.data.currentState = this.data.State.NORMAL;
        else if (average <= 61) this.data.currentState = this.data.State.AWE;
        else if (average <= 79) this.data.currentState = this.data.State.HAPPY;
        else this.data.currentState = this.data.State.WHAT;

        this.face.loadFaceExpresion();
    }


    updateColors() {
        const love = this.data.creatureStats.love;
        const food = this.data.creatureStats.food;
        const activity = this.data.creatureStats.activity;

        let baseColor;
        let outerColor;
        let innerColor;

        let alpha = 1.0;

        if (love >= 50) {
            baseColor = this.data.hairColors.base.clone();
            baseColor.lerp(this.data.hairColors.red, (love - 50) / 50);//Math.pow(layer / (layerCount - 1), 20)); // Bias towards insideColor
        }
        else if (love < 50) {
            baseColor = this.data.hairColors.base.clone();
            baseColor.lerp(this.data.hairColors.black, Math.abs(love - 50) / 50);
        }
        if (food >= 50) {
            outerColor = this.data.hairColors.outer.clone();
            outerColor.lerp(this.data.hairColors.green, (food - 50) / 50);

            //hair alpha
            const minAlpha = 0; // Minimum opacity
            const maxAlpha = 1.0;  // Maximum opacity
            const scale = 2; // Adjust smoothness (lower = slower change)

            // Sigmoid-based smooth transition
            alpha = minAlpha + (maxAlpha - minAlpha) / (1 + Math.exp(-scale * (95 - food)));
        }
        else if (food < 50) {
            outerColor = this.data.hairColors.outer.clone();
            outerColor.lerp(this.data.hairColors.grey, Math.abs(food - 50) / 50);

            //hair alpha
            const minAlpha = 0.02; // Minimum opacity
            const maxAlpha = 1.0;  // Maximum opacity
            const scale = 0.2; // Adjust smoothness (lower = slower change)

            // Sigmoid-based smooth transition
            alpha = minAlpha + (maxAlpha - minAlpha) / (1 + Math.exp(-scale * (food - 25)));

        }
        if (activity >= 50) {
            innerColor = this.data.hairColors.inner.clone();
            innerColor.lerp(this.data.hairColors.orange, (activity - 50) / 50 * 1.1);
        }
        else if (activity < 50) {
            innerColor = this.data.hairColors.inner.clone();
            innerColor.lerp(this.data.hairColors.blue, Math.abs(activity - 50) / 50 * 1.1);
        }

        const newColors = {
            base: baseColor,
            outer: outerColor,
            inner: innerColor
        };

        this.hair.updateHairColors(newColors);
        this.hair.updateHairAlpha(alpha);

        if (food > 95)
            this.body.updateBodyColor(outerColor);
        else
            this.body.updateBodyColor(baseColor);
        this.body.updateBodyAlpha(food / 100);
    }

    updateBreathing(isLove) {
        let newSpeed = 1;
        if (isLove) {
            const baseSpeed = 1;
            const speedFactor = 0.1;
            const mappedLove = this.data.creatureStats.love - 50;
            newSpeed = baseSpeed + Math.abs(mappedLove) * speedFactor;
        }
        else {
            if (this.data.creatureStats.activity < 5)
                newSpeed = 0;
            else if (this.data.creatureStats.activity < 15)
                newSpeed = 0.2;
            else if (this.data.creatureStats.activity < 25)
                newSpeed = 0.4;
            else if (this.data.creatureStats.activity < 35)
                newSpeed = 0.6;
            else if (this.data.creatureStats.activity < 45)
                newSpeed = 0.8;
            else
                newSpeed = 1;
        }

        this.body.changeBreathing(newSpeed);
    }

    updateHairSpeed() {
        const activity = this.data.creatureStats.activity;

        // Speed mapping (0.2 at 50, 0 at 0, 4 at 100)
        let speed = activity >= 50
            ? 0.2 + ((activity - 50) / 50) * (4 - 0.2)  // 50 to 100 → 0.2 to 4
            : 0.2 - ((50 - activity) / 50) * (0.2 - 0); // 50 to 0 → 0.2 to 0

        // Intensity mapping (0.3 at 50, 0 at 0, 0.8 at 100)
        let intensity = activity >= 50
            ? 0.3 + ((activity - 50) / 50) * (0.8 - 0.3) // 50 to 100 → 0.3 to 0.8
            : 0.3 - ((50 - activity) / 50) * (0.3 - 0);  // 50 to 0 → 0.3 to 0

        // Distance mapping (8.0 at 50, 20 at 0, 0.3 at 100)
        let distance = activity >= 50
            ? 8.0 - ((activity - 50) / 50) * (8.0 - 0.3)  // 50 to 100 → 8.0 to 0.3
            : 8.0 + ((50 - activity) / 50) * (20 - 8.0);  // 50 to 0 → 8.0 to 20

        // Apply updated values
        this.hair.updateHairSpeed(speed, intensity, distance);
    }

    updateLoveMessages() {
        let message = 'love';
        if (this.data.creatureStats.love < 50)
            message = 'hate';
        this.udpateMessages(message, this.data.creatureStats.love);
    }
    updateFoodMessages() {
        let message = 'full';
        if (this.data.creatureStats.food < 50)
            message = 'hungry';
        this.udpateMessages(message, this.data.creatureStats.food);
    }

    updateActivityMessages() {
        let message = 'excited';
        if (this.data.creatureStats.activity < 50)
            message = 'depressed';
        this.udpateMessages(message, this.data.creatureStats.activity);
    }

    udpateMessages(message, val) {
        switch (val) {
            case 5:
                this.showMessage(message, 5);
                break;
            case 15:
                this.showMessage(message, 4);
                break;
            case 25:
                this.showMessage(message, 3);
                break;
            case 35:
                this.showMessage(message, 2);
                break;
            case 45:
                this.showMessage(message, 1);
                break;
            case 55:
                this.showMessage(message, 1);
                break;
            case 65:
                this.showMessage(message, 2);
                break;
            case 75:
                this.showMessage(message, 3);
                break;
            case 85:
                this.showMessage(message, 4);
                break;
            case 95:
                this.showMessage(message, 5);
                break;
        }
    }

    blockEverything() {
        this.camera.controls.target.set(0, 0, 0); // Reset target to original point
        this.camera.instance.position.set(0, 0, 5); // Reset camera position
        this.camera.controls.update(); // Apply changes


        if (this.debug.active)
            this.debug.ui.domElement.style.visibility = "hidden"; // Hide but keep state
        else
            this.ui.blockEverything();

        document.body.style.pointerEvents = "none"; // Disable clicks
        this.interactionEnabled = false; //Disable interactions in three-js (implemented everywhere) TODO

        setTimeout(() => {
            this.reset();
        }, 4000);
    }

    reset() {
        if (this.debug.active) {
            this.debug.ui.domElement.style.visibility = "visible"; // Restore without resetting values
            this.loveControl.setValue(50);
            this.foodControl.setValue(50);
            this.activityControl.setValue(50);
        }
        else
            this.ui.reset();

        document.body.style.pointerEvents = "auto"; // Re-enable clicks
        this.interactionEnabled = true; // Enable interactions in three-js

        this.messageElements[6].style.display = "none";

        this.body.reset();
        this.hair.reset();
    }


    update() {
        this.body.update();
        this.face.update();
        this.hair.update();
    }

    resize() {
        this.body.resize();
        this.face.resize();
        this.hair.resize();
    }
}